import useSWR from "swr";
import axios from "axios";
import {createUrl, jigpawAPI} from "./API";
import {useRef} from "react";


const getCurrencyOverride = () => {
  const params = new URLSearchParams(window.location.search);
  const currency = params.get('currency');
  if (currency) {
    return currency.toUpperCase();
  }
  return null;
}

const fetchWithToken = async (url, user) => {
  const token = await user.getIdToken();
  return axios.get(url, {
    headers: {
      'Authorization': 'Bearer ' + token
    },
  }).then(res => res.data);
}

export const useLocale = (user) => {
  const overrideApplied = useRef(false);
  const { data, mutate, error } = useSWR([createUrl('api/locale'), user], fetchWithToken);

  const currencyOverride = getCurrencyOverride();

  // If a ?currency= param is in the URL, override the locale and persist it
  if (data && currencyOverride && data.currencyCode !== currencyOverride && !overrideApplied.current) {
    overrideApplied.current = true;
    const newLocale = { ...data, currencyCode: currencyOverride };
    mutate(
      jigpawAPI.update_currency(user, currencyOverride),
      { optimisticData: newLocale, revalidate: false, populateCache: true, rollbackOnError: true }
    );
  }

  return {
    locale: data,
    isLoading: !error && !data,
    error: error,
    update: mutate
  };
};
